import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            赛事分类
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            选择您擅长的竞技领域
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm">
            六大竞技类别，每天更新赛制，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const colorMap: Record<string, { bg: string; text: string; border: string; iconBg: string }> = {
              primary: {
                bg: 'bg-primary-50 hover:bg-primary-100/70',
                text: 'text-primary-700',
                border: 'border-primary-200/60',
                iconBg: 'bg-primary-500',
              },
              accent: {
                bg: 'bg-accent-50 hover:bg-accent-100/70',
                text: 'text-accent-700',
                border: 'border-accent-200/60',
                iconBg: 'bg-accent-500',
              },
              secondary: {
                bg: 'bg-secondary-50 hover:bg-secondary-100/70',
                text: 'text-secondary-700',
                border: 'border-secondary-200/60',
                iconBg: 'bg-secondary-500',
              },
            };
            const colors = colorMap[cat.color] || colorMap.primary;

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`block p-6 rounded-xl border transition-all duration-300 cursor-pointer group ${colors.bg} ${colors.border}`}
              >
                <div className={`w-12 h-12 rounded-xl ${colors.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <i className={`${cat.icon} text-background-50 text-xl`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  {cat.description}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <span>{cat.count} 场赛事</span>
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}